// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2Tpiv","label":"LabeledBox_label__XJjeL"};